/* eslint-disable */
import Storage from "../storage/storage.js";
import Services from "../services/services.js";

export default class ServiceWorker {
  static getPushState() {
    const prevPermission = Storage.getPermission();

    if ("Notification" in window) {
      if (Notification.permission === "granted") {
        return 200;
      } else if (Notification.permission !== "denied") {
        if (!prevPermission) {
          return 2;
          //در حالت دیفالت هست و قبلا هینت پرمیشن گرفته نشده
        } else {
          if (!prevPermission.pushMessage) {
            return 3;
          } else {
            //در حالت دیفالت هست و قبلا هینت پرمیشن گرفته شده و باید خود پرمیشن اجرا شود
            return 4;
          }
        }
      } else if (Notification.permission === "denied") {
        if (!prevPermission) {
          return 5;
        } else {
          if (!prevPermission.pushMessage) {
            return 6;
          } else {
            return 7;
          }
        }
      }
    }
  }

  static pushPermissionReq({ onAccept, onReject }) {
    SW?.registration?.pushManager
      .subscribe({
        userVisibleOnly: true,
        applicationServerKey: SW.pushPUK,
      })
      .then((permission) => {
        onAccept(permission);
      })
      .catch((res) => {
        onReject(res);
      });
  }

  static async getSubscriptionToken() {
    const subscription = await SW?.registration?.pushManager?.getSubscription();
    if (!subscription) {
      return false;
    }
    return subscription;
  }

  static async setMyEndPointAsACLConnector(iden) {
    const subscription = await ServiceWorker.getSubscriptionToken();
    const userInfo = Storage.getUser();
    let identifier;
    try {
      if (subscription) {
        identifier = JSON.stringify(subscription);
      }
    } catch (e) {}

    if (identifier) {
      const result = await Services.Req({
        data: {
          app: "users",
          view: "setMyACLConnector",
          type: "browser",
          scope: "endpoint",
          // publishDown: subscription?.expirationTime,
          identifier,
          userID: userInfo?.ID || "0",
        },
      });
      if (result?.AclConnector) {
        Storage.setPermission({ type: "endPointACLConnector", value: true });
      }
      return result;
    }
  }
}
